import { cn } from "@/lib/utils";

const STEP_ORDER = ["status", "preview", "scanner", "signal"];

const STEP_LABELS = {
  status: "Status",
  preview: "Preview",
  scanner: "Scanner",
  signal: "Signal",
};

export const UserPipelineStatusBar = ({
  statusReady = false,
  previewReady = false,
  scannerReady = false,
  signalReady = false,
}) => {
  const stateMap = {
    status: Boolean(statusReady),
    preview: Boolean(previewReady),
    scanner: Boolean(scannerReady),
    signal: Boolean(signalReady),
  };

  const completedCount = STEP_ORDER.filter((key) => stateMap[key]).length;
  const progressPercent = Math.round((completedCount / STEP_ORDER.length) * 100);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid="user-pipeline-status-bar">
      <div className="mb-4 flex items-center justify-between gap-3" data-testid="user-pipeline-status-bar-header">
        <h2 className="text-base font-semibold text-slate-900" data-testid="user-pipeline-status-bar-title">Pipeline Bar</h2>
        <span className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold text-slate-600" data-testid="user-pipeline-status-bar-progress-label">
          %{progressPercent} tamam
        </span>
      </div>

      <div className="mb-4 h-2 overflow-hidden rounded-full bg-slate-100" data-testid="user-pipeline-status-bar-track">
        <div
          className="h-full rounded-full bg-gradient-to-r from-cyan-500 to-emerald-500 transition-all duration-500"
          style={{ width: `${progressPercent}%` }}
          data-testid="user-pipeline-status-bar-fill"
        />
      </div>

      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-testid="user-pipeline-status-bar-steps">
        {STEP_ORDER.map((stepKey) => {
          const completed = stateMap[stepKey];
          return (
            <article
              key={stepKey}
              className={cn(
                "rounded-xl border px-3 py-2 transition-colors",
                completed ? "border-emerald-200 bg-emerald-50" : "border-slate-200 bg-slate-50",
              )}
              data-testid={`user-pipeline-status-step-${stepKey}`}
            >
              <p className="text-[11px] uppercase tracking-wider text-slate-500" data-testid={`user-pipeline-status-step-label-${stepKey}`}>
                {STEP_LABELS[stepKey]}
              </p>
              <p className={cn("text-sm font-semibold", completed ? "text-emerald-700" : "text-slate-700")} data-testid={`user-pipeline-status-step-state-${stepKey}`}>
                {completed ? "Hazır" : "Bekliyor"}
              </p>
            </article>
          );
        })}
      </div>
    </section>
  );
};
